import { useEffect, useRef } from "react";
import { useLocationSelection } from "../../context/LocationContext";
import LocationCard from "./LocationCard";

function LocationSelector({ open, onClose, onLocationSelected }) {
  const dialogRef = useRef(null);
  const closeButtonRef = useRef(null);
  const { locations, locationsLoading, locationsError, chooseLocation } = useLocationSelection();

  useEffect(() => {
    if (!open) return undefined;

    closeButtonRef.current?.focus();

    function handleKeyDown(event) {
      if (event.key === "Escape") {
        onClose();
      }
    }

    document.addEventListener("keydown", handleKeyDown);
    return () => document.removeEventListener("keydown", handleKeyDown);
  }, [open, onClose]);

  if (!open) {
    return null;
  }

  function handleLocationSelect(location) {
    const result = chooseLocation(location);

    if (result.needsConfirmation) {
      const shouldSwitch = window.confirm(
        "Switching locations will clear the items currently in your cart. Continue?"
      );

      if (!shouldSwitch) {
        return;
      }

      chooseLocation(location, { clearCart: true });
    }

    onLocationSelected(location);
  }

  return (
    <div className="public-modal-backdrop" role="presentation" onMouseDown={onClose}>
      <section
        aria-labelledby="location-selector-title"
        aria-modal="true"
        className="public-location-modal"
        onMouseDown={(event) => event.stopPropagation()}
        ref={dialogRef}
        role="dialog"
      >
        <div className="public-modal-header">
          <div>
            <p className="eyebrow">Choose where to order</p>
            <h2 id="location-selector-title">Select your Zayas Kitchen location.</h2>
          </div>
          <button
            aria-label="Close location selector"
            className="btn btn-light btn-icon"
            onClick={onClose}
            ref={closeButtonRef}
            type="button"
          >
            �
          </button>
        </div>

        {locationsLoading ? (
          <div className="empty-state">Loading locations...</div>
        ) : null}

        {locationsError ? (
          <div className="alert alert-warning">
            <strong>Locations are not available yet.</strong>
            <span>Please try again in a moment.</span>
          </div>
        ) : null}

        {!locationsLoading && !locationsError && locations.length === 0 ? (
          <div className="empty-state">No active locations are available right now.</div>
        ) : null}

        <div className="public-location-grid">
          {locations.map((location) => (
            <LocationCard key={location.id} location={location} onSelect={handleLocationSelect} />
          ))}
        </div>
      </section>
    </div>
  );
}

export default LocationSelector;